import { render } from "./Title2App.vue?vue&type=template&id=52de2c42"
import script from "./Title2App.vue?vue&type=script&lang=js"
export * from "./Title2App.vue?vue&type=script&lang=js"

import "./Title2App.vue?vue&type=style&index=0&id=52de2c42&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__